import { Company } from '@app/core/model/company.model'
import { Preference } from '@app/core/model/user-preferences.interface'
import { RatecardVersion } from '@app/features/scope-overview/model/ratecard-version.model'
import { TableColumnKey } from '@app/shared/components/ui-components/scope-ui-table/table-column-key.enum'

export function getRateCardsColumnsBaseConfig(company: Company): Record<string, Preference> {
  return {
    NAME: {
      key: TableColumnKey.NAME,
      name: 'Name',
      field: 'name',
      selected: true,
      valueIconFunction: () => 'credit_card',
      valueIconFunctionSecondary: (rateCard: RatecardVersion) =>
        rateCard.rateCardIdentity.trafficImported ? 'swap_vert' : '',
      valueBadgeText: (rateCard: RatecardVersion) => (rateCard.rateCardIdentity?.defaultCard ? 'DEFAULT' : null),
    },
    [TableColumnKey.SCOPE_NUMBER]: {
      key: TableColumnKey.SCOPE_NUMBER,
      name: 'Inherited',
      value: () => 'Inherited from parent',
      isVisible: (entity: RatecardVersion) => entity.isInherited(company),
      selected: true,
    },
    CURRENCY: {
      key: TableColumnKey.CURRENCY,
      name: 'Currency',
      field: 'currencyCode',
      selected: true,
    },
    VERSION: {
      key: TableColumnKey.VERSION,
      name: 'Version',
      field: 'version',
      selected: true,
    },
    CREATED_BY: {
      key: TableColumnKey.CREATED_BY,
      name: 'Created By',
      field: 'createdBy.fullName',
      selected: true,
    },
    CREATED_DATE: {
      key: TableColumnKey.DATE_CREATED,
      name: 'Created Date',
      field: 'createdTs',
      selected: true,
    },
    UPDATED_BY: {
      key: TableColumnKey.UPDATED_BY,
      name: 'Updated By',
      field: 'updatedBy.fullName',
      selected: true,
    },
    UPDATED_DATE: {
      key: TableColumnKey.LAST_EDITED,
      name: 'Updated Date',
      field: 'updatedTs',
      selected: true,
    },
  }
}
